import { Injectable } from '@angular/core';
import { ApiService } from './api';
import { Observable } from 'rxjs';
import { ChangeHistory } from '../reports/change-history/change-history.model';

@Injectable({ providedIn: 'root' })
export class AirlineUasService {
  path: string = '/api';
  constructor(private apiService: ApiService) { }

  getDraftUasByType(airlineId: string, uaPath: string) {
    return this.apiService.get(`${this.path}/airlines/${airlineId}/${uaPath}?status=draft`);
  }
  getPendingUasByType(airlineId: string, uaPath: string) {
    return this.apiService.get(`${this.path}/airlines/${airlineId}/${uaPath}?status=pending`);
  }
  getPublishedUasByType(airlineId: string, uaPath: string) {
    return this.apiService
      .get(`${this.path}/airlines/${airlineId}/${uaPath}?status=published`);
  }
  getDisabledUasByType(airlineId: string, uaPath: string) {
    return this.apiService.get(`${this.path}/airlines/${airlineId}/${uaPath}?status=disabled`);
  }
  getChangelogUas(airlineId: string):  Observable<{[timestampAndAction: string]: ChangeHistory[]}> {
    return this.apiService.get(`${this.path}/v2/airlines/${airlineId}/upa_change_logs`);
  }
  getAdminChangelogUas(fromDate: string, thruDate: string): Observable<{[timestampAndAction: string]: ChangeHistory[]}> {
    return this.apiService.get(`${this.path}/v2/airlines/upa_change_logs?from=${fromDate}&thru=${thruDate}`);
  }
}
